import { render, staticRenderFns } from "./OpenBankingPaymentStatusLabel.vue?vue&type=template&id=a1160b82"
import script from "./OpenBankingPaymentStatusLabel.vue?vue&type=script&lang=js"
export * from "./OpenBankingPaymentStatusLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports